var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptySearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.3571 95L51.5714 78.2143C55.5 73.2143 57.6429 67.1429 57.6429 60.7143C57.6429 45 44.7857 32.1429 29.0714 32.1429C13.3571 32.1429 0.5 45 0.5 60.7143C0.5 76.4286 13.3571 89.2857 29.0714 89.2857C35.5 89.2857 41.5714 87.1429 46.5714 83.2143L63.3571 100L68.3571 95ZM29.0714 82.1429C17.2857 82.1429 7.64286 72.5 7.64286 60.7143C7.64286 48.9286 17.2857 39.2857 29.0714 39.2857C40.8571 39.2857 50.5 48.9286 50.5 60.7143C50.5 72.5 40.8571 82.1429 29.0714 82.1429ZM71.9286 35.7143H100.5V42.8571H71.9286V35.7143ZM43.3571 17.8571H100.5V25H43.3571V17.8571ZM43.3571 0H100.5V7.14286H43.3571V0Z",
    fill: "#E5E7EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/empty-search.cb97ac37956cf19c34a13b0547cffdb6.svg";
export { ForwardRef as ReactComponent };